<template>
    <div class="DataUpdate">
        <modal name="CertificateModal" width="700" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false">
            <div class="tabcontent">
                <ValidationObserver ref="obsFieldsUpdate">
                    <Formupdate
                    :FieldsForm="formUpdate"
                    :ModelForm="formUpdModel"
                    :method="executeProcess"
                    v-if="renderComponent2"
                    />
                </ValidationObserver>
                    <div class="modalActions">
                        <button v-if="isNew === false"
                            id="updateCertificate"
                            @click="updateCertificate"
                            class="loginbtn primaryBtn primaryBtn">
                        Actualizar
                        </button>

                        <button v-else
                            id="AddCertificate"
                            @click="AddCertificate"
                            class="loginbtn primaryBtn primaryBtn">
                        Guardar
                        </button>

                        <button
                            id="CancelUser"
                            @click="CancelUser"
                            class="loginbtn primaryBtn secondaryBtn">
                        Cancelar
                        </button>
                    </div>
                </div>
            </modal>
        <div class="titlePage">Administración - Tipos de Certificados</div>
        <va-notification color="info" v-if="addRExito" class="refNoData">Se creo correctamente el programa
            solicitado.</va-notification>
        <va-notification color="info" v-if="UpdRExito" class="refNoData">Se actualizo correctamente el programa
            solicitado.</va-notification>
        <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del programa presento un
            fallo.</va-notification>
        <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se
            encuentra activo.</va-notification>

        <ValidationObserver ref="obsFieldsSearch">
            <FormSearch :FieldsForm="formSearch" :ModelForm="formSchModel" :method="executeProcess" />
        </ValidationObserver>
        <va-notification color="danger" id="refNoData" class="refNoData noShow">No se encontró información del programa
            solicitado.</va-notification>
        <div class="listPrograms">
            <DataTable :InfoView="this.DLCertificate" :HeadTable="this.HDCertificate" :method="processData"
                v-if="renderComponent1" />
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearch from '@/components/forms/Forms.vue'
import Formupdate from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import IberoHelpers from '@/store/helpers.js'
// Data Table.
import DataTable from '@/components/data-tables/DataCertificate.vue'

export default {
    name: 'dataUpdate',
    components: {
        FormSearch,
        Formupdate,
        DataTable,
    },
    data() {
        return {
            formSchModel: {},
            formSearch: [
                {
                    id: 'Sch_Button',
                    type: 'button',
                    placeholder: 'Consultar Tipo de Certificado',
                    class: 'col-md-3',
                },
                {
                    id: 'Sch_ButtonNew',
                    type: 'button',
                    placeholder: 'Crear Tipo de Certificado',
                    class: 'col-md-3',
                },
            ],
            formUpdModel: {
                id: '',
                name: '',
                status: '',
                price: ''
            },

            formUpdate: [
                {
                    id: 'id',
                    model: 'id',
                    name: 'id',
                    type: 'input',
                    placeholder: 'Id',
                    values: '',
                    validate: {
                        required: true,
                        regex: '^([a-zA-z]?)',
                        max: 19,
                    },
                    class: 'col-md-6',
                },
                {
                    id: 'name',
                    model: 'name',
                    name: 'nombre',
                    type: 'input',
                    placeholder: 'nombre',
                    class: 'col-md-6',
                    validate: {
                        required: true,
                    },
                },

                {
                    id: 'status',
                    model: 'status',
                    name: 'Estado',
                    type: 'Select',
                    values: [
                        { id: 'true', value: 'Activo' },
                        { id: 'false', value: 'Inactivo' },
                        
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-6',
                },

                {
                    id: 'price',
                    model: 'price',
                    name: 'Precio',
                    type: 'input',
                    placeholder: 'Precio',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-6',
                },
            ],

            HDCertificate: [

                {
                    name: 'id',
                    title: 'Id',
                    sortField: 'id',
                    width: '10%',
                },
                {
                    name: 'name',
                    title: 'Nombre',
                    sortField: 'name',
                    width: '20%',
                },
                {
                    name: 'status',
                    title: 'Estado',
                    sortField: 'status',
                    width: '20%',
                },
                {
                    name: 'price',
                    title: 'Precio',
                    sortField: 'price',
                    width: '5%',
                },
                {
                    name: '__slot:actions',
                    dataClass: 'text-right',
                    actionRef: [
                        {
                            label: 'Editar',
                            icon: 'fa-pencil',
                            action: 'edit',
                        },
                    ],
                },

            ],
            DLCertificate: [],
            renderComponent1: false,
            renderComponent2: false,
            addRExito: false,
            UpdRExito: false,
            refNoUpdate: false,
            refWSUpdate: false,
            isNew: false,
        }
    },

    methods: {
        executeProcess: function (event, refer) {
            this.limpiaref()
            switch (event.target.id) {
                case 'btn_Sch_Button':
                    this.isNew = false
                    return new Promise((resolve, reject) => {
                        this.$refs.obsFieldsSearch.validate().then(results => {
                            if (!results) {
                                resolve(false)
                            } else {
                                this.searchForm()
                                resolve(true)
                            }
                        })
                    })
                case 'btn_Sch_ButtonNew':
                    this.limpiaref()
                    this.clearFields()
                    this.isNew = true
                    IberoHelpers.forceRerender2(this)
                    this.$modal.show('CertificateModal')
            }
            this.$refs.obsFieldsSearch.validate()
        },

        searchForm() {
            document.getElementById('refNoData').classList.add('noShow')
            this.isNew = false
            let loader = this.$loading.show()
            var listCertificate = IberoHelpers.GetCertificateType(this.$store, this.formSchModel, 0)
            this.renderComponent1 = false
            listCertificate.then(Response => {
                if ((Response.data === undefined) || (Response.data === '')) {
                    document.getElementById('refNoData').classList.remove('noShow')
                } else {
                    if (Array.isArray(Response.data)) {
                        this.DLCertificate = Response.data
                    } else {
                        this.DLCertificate = [Response.data]
                    }
                    IberoHelpers.forceRerender1(this)
                }
                loader.hide()
            })
        },

        updateCertificate() {
            this.limpiaref()
            return new Promise((resolve, reject) => {
                this.$refs.obsFieldsUpdate.validate().then(results => {
                    if (!results) {
                        resolve(false)
                    } else {
                        let loader = this.$loading.show()
                        var totalinf = IberoHelpers.EditCertificateType(this.$store, this.formUpdModel)
                        totalinf.then(Response => {
                            this.renderComponent1 = false
                            if (Response === false) {
                                this.refWSUpdate = true
                                resolve(false)
                            } else if (!(Response.status === 200)) {
                                this.refNoUpdate = true
                                resolve(false)
                            } else {
                                this.UpdRExito = true
                                resolve(true)
                            }
                            this.$modal.hide('CertificateModal')
                            this.searchForm()
                            loader.hide()
                        })
                    }
                })
            })
        },

        AddCertificate() {
            this.limpiaref()
            debugger
            return new Promise((resolve, reject) => {
                this.$refs.obsFieldsUpdate.validate().then(results => {
                    if (!results) {
                        resolve(false)
                    } else {
                        let loader = this.$loading.show()
                        
                        var totalinf = IberoHelpers.addCertificateType(this.$store, this.formUpdModel)
                        
                        totalinf.then(Response => {
                            
                            this.renderComponent1 = false
                            if (Response === false) {
                                this.refWSUpdate = true
                                resolve(false)
                            } else if (!(Response.status === 200)) {
                                this.refNoUpdate = true
                                resolve(false)
                            } else {
                                this.addRExito = true
                                resolve(true)
                            }
                            this.$modal.hide('CertificateModal')
                            this.searchForm()
                            loader.hide()
                        })
                    }
                })
            })
        },

        CancelUser() {
            this.limpiaref()
            this.clearFields()
            this.$modal.hide('CertificateModal')
        },

        limpiaref() {
            this.addRExito = false
            this.UpdRExito = false
            this.refNoUpdate = false
            this.refWSUpdate = false
            document.getElementById('refNoData').classList.add('noShow')
        },
        clearFields() {
            this.formUpdModel.id = ''
            this.formUpdModel.name = ''
            this.formUpdModel.status = ''
            this.formUpdModel.price = ''
        },

        processData: function (dataInf, refdata) {
            this.limpiaref()
            this.isNew = false
            this.formUpdModel.id = dataInf.id
            this.formUpdModel.name = dataInf.name
            this.formUpdModel.status = dataInf.status
            this.formUpdModel.price = dataInf.price
            IberoHelpers.forceRerender2(this)
            this.$modal.show('CertificateModal')
        },

    },
}
</script>